import * as React from "react";
import Typography from "../Typography";
import { FormattedDate, FormattedMessage } from "react-intl";
import * as styles from "./styles";
import { RightArrow2Icon } from "../../assets/icons/right-arrow-2";
import { colors } from "../../styles/styles";
import { HooplaEventPurchase } from "../../types";
import Button, { OutsideLinkButton } from "components/Button";
import { ticketsDownloaded } from "../../gtm";
import { ReactComponent as IconCross } from "../../assets/icons/icon_cross.svg";
import { getDomain } from "helpers/getDomain";

interface IPurchaseRowProps {
  purchases: HooplaEventPurchase[];
  eventId: number;
}

const downloadTickets = (purchaseId: string, hash: string) => {
  window.location.href = `/api/v4.0/pdf/purchases/${purchaseId}/?h=${hash}`;
  ticketsDownloaded(parseInt(purchaseId, 10));
};

const getPurchaseActions = (
  eventId: number,
  purchase: HooplaEventPurchase,
  isExpanded: boolean,
  onExpand: () => void,
  onClose: () => void,
) => {
  if (!isExpanded) {
    if (purchase.numberOfTickets === purchase.numberOfRevokedTickets) {
      return (
        <button className={styles.arrow} disabled>
          <RightArrow2Icon color={colors.red_00} size={25} />
        </button>
      );
    }
    return (
      <button className={styles.arrow} onClick={onExpand}>
        <RightArrow2Icon color={colors.hooplaBlue} size={25} />
      </button>
    );
  }

  if (purchase.numberOfTickets < 1) {
    return null;
  }

  return (
    <div className={styles.expandableButtons}>
      <Button
        variant="white"
        size="small"
        onClick={() => downloadTickets(String(purchase.purchase.purchaseId), purchase.refCodeHash)}
      >
        <FormattedMessage id="components.TicketList.download" />
      </Button>
      <OutsideLinkButton
        size="small"
        variant="lightblue"
        to={`https://m.${getDomain()}/p/${purchase.refCode}.${purchase.refCodeHash}`}
      >
        <FormattedMessage id="components.TicketList.show" />
      </OutsideLinkButton>
      <Button variant="white" size="small" onClick={onClose}>
        <IconCross height="16" />
      </Button>
    </div>
  );
};

const PurchaseTableNarrow: React.FC<IPurchaseRowProps> = ({ purchases, eventId }) => {
  const [expanded, setExpanded] = React.useState("");

  return (
    <tbody>
      {purchases.map((purchase) => (
        <tr key={purchase.purchase.purchaseId}>
          <td />
          <td>
            <Typography>
              <FormattedDate
                value={purchase.purchase.finalized}
                day="numeric"
                month="long"
                year="numeric"
              />
            </Typography>
          </td>
          <td>
            <Typography>{purchase.purchase.purchaseId}</Typography>
          </td>
          <td>
            <Typography>
              <FormattedMessage
                id="components.TicketList.numTickets"
                values={{
                  tickets: purchase.numberOfTickets,
                  revoked:
                    purchase.numberOfTickets - purchase.numberOfRevokedTickets > 0
                      ? purchase.numberOfRevokedTickets
                      : 0,
                }}
              />
            </Typography>
          </td>
          <td>
            <div className={styles.purchaseActions}>
              {getPurchaseActions(
                eventId,
                purchase,
                expanded === purchase.purchase.purchaseId,
                () => setExpanded(purchase.purchase.purchaseId),
                () => setExpanded(""),
              )}
            </div>
          </td>
        </tr>
      ))}
    </tbody>
  );
};

export default PurchaseTableNarrow;
